<template>
  <div style="">
    <div :style="{textalign: 'left',width:searchTextWidth}">
      <h2 class="account-panel-head">
        {{mytitle}}
        <i class="account-panel-hide" @click="clearSelect" v-if="flag"></i>
      </h2>
      <div id="orgSearch" class="account-panel-detail">
        <div class="org-panel-srh">
          <i class="org-srh-icon" @click=""></i>
          <input type="text" class="org-srh-input" v-model="filterText" placeholder="输入关键字或首字母" @focus="handleFocus"/>

        </div>
      </div>
    </div>
    <el-tree :data="data" :props="defaultProps" :show-checkbox="isShowCheckBox"
             :default-expanded-keys="mydefaultexpandedkeys" :default-checked-keys="defaultcheckednode"
             :filter-node-method="filterNode" node-key="id" :expand-on-click-node="false"
             @check="handleCheck" @node-click="handleNodeClick" ref="tree1"></el-tree>
  </div>
</template>

<script>
  import {getEmployeeTree} from '@/api/set/employee'
  import {convertPinyin} from '@/plugin/vue-py'

  export default {
    name: "pagination",
    data() {
      return {
        flag: false,
        buttonHeight: 40,
        visible: this.showForever,
        filterText: this.searchText,
        defaultcheckednode:[],
        mydefaultexpandedkeys: this.defaultexpandedkeys,
        mytitle: this.title,
        defaultProps: {
          children: 'children',
          label: 'text',
        },
        data: [],
      }
    },
    props: {
      treeWidth: {   //宽度
        default: 250
      },
      treeHeight: {   //高度
        default: 250
      },
      searchTextWidth: {
        default: '96%'
      },
      isShowCheckBox: {//多选
        default: false
      },
      onlyChildNodesCheckBox: {   //多选时,当选中父节点和 子节点时，是否返回父节点信息，默认只返回子节点信息
        default: true
      },
      canSelectGroupTypeNode: {//是否允许选择类目节点，默认否 。例如人员树，只能选择人员不能选择部门，商品树不能选择商品类别。
        default: false
      },
      onlyShowGroupType: {//是否只显示类目节点，例如只显示部门。 默认 否
        default: false
      },
      defaultCheckedKeys: {//默认选中的节点数组
        default: () => []
      },
      defaultexpandedkeys: {//默认展开的节点
        default: () => []
      },
      searchText: {//单选时搜索区域显示文本，
        default: ""
      },
      showForever: {//永远显示不关闭
        default: true
      },
      defineDataSource: {// 是否自定义数据源  默认否
        default: false
      },
      needTopNode: {// 是否需要顶级节点
        default: false
      },
      topNodeText: {// 顶级节点显示文本
        default: "顶级节点"
      },
      readonly: {
        default: false
      },
      title: {//标题
        default: '请选择'
      },

    },

    watch: {
      filterText(val) {
        if (this.$refs.tree1) {
          this.$refs.tree1.filter(val);
        }
      },
      searchText(val) {
        this.filterText = this.searchText
      },
      defaultexpandedkeys(newval, oldval) {
        this.mydefaultexpandedkeys = newval
      },
      title(newval, oldval) {
        this.mytitle = newval
      }
    },

    methods: {
      getNode(id){
        return this.$refs.tree1.getNode(id);
      },
      clearSelect() {
        this.filterText = ''
        this.flag = false
        this.mytitle = "请选择"
        this.$emit("check", '', '', []);
      },
      handleNodeClick(data) {

        if (!this.isShowCheckBox) {
          //只有单选时.点击事件才有效
          if (this.onlyShowGroupType || this.canSelectGroupTypeNode || (!this.canSelectGroupTypeNode && !(data.attributes && data.attributes.GroupType))) {
            //允许选择类目节点， 或者不允许选择类目节点时的 非类目节点。
            let ids = data.id
            let texts = data.text
            let sels = []
            sels.push(data)//为了兼容多选， 使得父组件处理方式相同，故写成数组。
            if (!this.showForever) {
              this.visible = false
            }
            this.flag = true;
            this.mytitle = data.text
            this.$emit("check", ids, texts, sels);
          }
        }

      },
      reset() {//初始化
        this.flag = false;
        this.filterText = ""
        this.visible = false
        if (this.isShowCheckBox) {
          if (this.$refs.tree1) {
            this.$refs.tree1.setCheckedKeys([])
          }
        }
      },
      setCheckedKeysNoemit(arr){
        this.$refs.tree1.setCheckedKeys(arr);
      },
      cancelCheck() {
        this.$refs.tree1.setCheckedKeys([])
        this.filterText = ""
        this.$emit("check", "", "", []);
      },
      setCheckedNoemit(key,check) {
        this.$refs.tree1.setChecked(key, check)
      },
      closeTree() {
        this.visible = false
      },
      setDefault(value) {
        this.defaultcheckednode =value;
      },
      handleFocus(event) {
        if (this.readonly) {
          return
        }
        this.visible = true
        //选中默认节点
        if (this.isShowCheckBox && this.defaultCheckedKeys.length > 0) {
          if (this.$refs.tree1) {
            this.$refs.tree1.setCheckedKeys(this.defaultCheckedKeys)
            let obj1 = this.getCheckedData()
          }
        }
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.text.indexOf(value) !== -1 || data.py.indexOf(value) !== -1;
      },
      handleChange(data, node) {
      },
      handleCheck(data, node) {
        //选中单个的节点
        var obj1 = this.getCheckedData()
        this.$emit("check", obj1.ids, obj1.texts, obj1.sels);
      },
      getCheckedData() {
        var sels = this.$refs.tree1.getCheckedNodes(this.onlyChildNodesCheckBox)
        var ids = "", texts = "";
        if (!this.canSelectGroupTypeNode) {
          for (let i in sels) {
            if (!sels[i].attributes || !sels[i].attributes.GroupType) {
              ids += sels[i].id + ";"
              texts += sels[i].text + "、"
            }
          }
        }
        if (ids != "") {
          ids = ids.substr(0, ids.length - 1)
          texts = texts.substr(0, texts.length - 1)
        }
        //this.defaultCheckedKeys = ids.split(';')
        var obj1 = {};
        obj1.ids = ids
        obj1.texts = texts
        obj1.sels = sels
        return obj1
      },
      isArray(obj1) {
        return Array.isArray(obj1) || obj1 instanceof Array
      },
      ChangeToPY(rowdata) {
        for (let rowIndex in rowdata) {
          rowdata[rowIndex]['py'] = convertPinyin(rowdata[rowIndex].text);
          if (rowdata[rowIndex].children.length > 0)
            this.ChangeToPY(rowdata[rowIndex].children);
        }
      },
      bindData(fun) {
        if (fun && typeof(fun) == "function") {//接收父组件的绑定数据的函数。
          fun().then((result) => {
            if (!this.isArray(result.data.obj)) {
              this.data = [result.data.obj]
            } else {
              this.data = result.data.obj
            }
            this.ChangeToPY(this.data);
            if (this.defaultexpandedkeys.length == 0 && this.data.length > 0) {
              this.mydefaultexpandedkeys = ['-1', this.data[0].id];
            }
            try {
              this.$emit("afterBindTree", this.data)
            } catch (ex) {
            }
          })
        } else {//默认是获取人员
          getEmployeeTree({onlyShowGroupType: this.onlyShowGroupType, needTopNode: this.needTopNode}).then((result) => {
            if (!this.isArray(result.data.obj)) {
              result.data.obj.text = this.topNodeText
              this.data = [result.data.obj]
            } else {
              this.data = result.data.obj
            }
            this.ChangeToPY(this.data);
            if (this.defaultexpandedkeys.length == 0 && this.data.length > 0) {
              this.mydefaultexpandedkeys = ['-1', this.data[0].id];
            }
            try {
              this.$emit("afterBindTree", this.data)
            } catch (ex) {
            }
          })
        }
      }
    },
    mounted() {
      if (!this.defineDataSource) {
        this.bindData()
      } else {
        this.$emit("bindData")
      }
    },
  }
</script>

<style scoped>
  .el-tree {
    background-color: white;
    overflow: auto;
    /*height: calc(100vh - 104px);*/
    height: 100%;
    /*width: 250px;*/
  }

  .account-panel-detail {
    position: relative;
    height: 100%;
  }

  .account-panel-head {
    position: relative;

    padding-left: 10px;

    font-size: 16px;
    line-height: 36px;

    color: #2586d9;
    border-bottom: 1px solid #ddd;
    background-color: #f4f4f4;
  }

  .account-panel-hide {
    position: absolute;
    top: 50%;
    right: 10px;
    width: 22px;
    height: 22px;
    margin-top: -11px;
    cursor: pointer;
    background: url('../../assets/images/icon-toright-clean.png');
  }

  .org-panel-srh {
    display: table;
    width: 100%;
    margin: 10px;
  }

  .org-srh-input,
  .org-srh-icon {
    display: table-cell;
  }

  .org-srh-icon {
    cursor: pointer;
    width: 35px;
    background: url(../../assets/images/search-bg.png);
  }

  .org-srh-input {
    width: 80%;
    height: 28px;
    padding-left: 6px;

    font-size: 12px;
    line-height: 28px;

    color: #666;

    border: 1px solid #2a92eb;
    border-left: 0;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    outline: none;
    float: left;
  }

  /*.selemployeediv {*/
  /*position: relative;*/
  /*}*/

  /*.selemployeediv-content {*/
  /*width: 250px;*/
  /*position: absolute;*/
  /*border: 1px solid #F0F0F0;*/
  /*z-index: 9999999;*/
  /*background-color: white;*/
  /*}*/

  /*.treeButton {*/
  /*text-align: center !important;*/

  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/common/CommonTreeView.vue